import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-[#f7f7f6] relative overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo to="/" size="h-14" className="mb-6" testId="footer-logo" />
            <p className="font-display text-3xl md:text-4xl font-extrabold tracking-tight leading-[1.05] max-w-md">
              Securing technology. Protecting data. Powering the circular economy.
            </p>
            <a
              href="#quote"
              className="inline-flex items-center gap-2 mt-8 bg-primary text-white px-6 py-4 font-mono text-xs uppercase tracking-wider hover:bg-white hover:text-black transition-colors"
            >
              Start a Project <ArrowUpRight size={16} />
            </a>
            <p className="font-mono text-[11px] text-white/40 mt-8 tracking-widest">USA · UK · SINGAPORE · INDIA · UAE</p>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-5">Services</p>
            <ul className="space-y-3 font-sans text-white/60 text-sm">
              <li>IT Asset Disposition (ITAD)</li>
              <li>Secure Data Destruction</li>
              <li>Data Center Decommissioning</li>
              <li>Technology Lifecycle Management</li>
              <li>Buyback & Value Recovery</li>
              <li>Sustainable E-Waste Recycling</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-5">Connect</p>
            <ul className="space-y-3 font-sans text-white/60 text-sm">
              <li>Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, UAE</li>
              <li>PO Box 417541</li>
              <li><a href="mailto:kk@envirotek.net" className="hover:text-primary transition-colors">kk@envirotek.net</a></li>
              <li><a href="tel:+971503506857" className="hover:text-primary transition-colors">+971 50 350 6857</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono text-xs text-white/40">© {new Date().getFullYear()} ENVIROTEK LLC FZ. ALL RIGHTS RESERVED.</p>
          <p className="font-mono text-xs text-white/40">GLOBAL ITAD · 70+ COUNTRIES · NIST 800-88</p>
        </div>
      </div>
    </footer>
  );
}
